<template>
    <div class="app">
        <div class="authentication">
            <div class="sign-in">
                <div class="row no-mrg-horizon">
                    <div class="col-md-7 no-pdd-horizon d-none d-md-block">
                        <div class="full-height bg" style="background-image: url('img/cover.jpg')">
                            <div class="img-caption">
                                <h1 class="caption-title">Mesurer, Optimiser, Partager.</h1>
                                <p class="caption-text">Kemtag permet aux gestionaires de parcs de suivre l'utilisation de leurs outils.</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-5 no-pdd-horizon">
                        <div class="full-height bg-white height-100">
                            <div class="vertical-align full-height pdd-horizon-70">
                                <div class="table-cell">
<!-- ######################################################################################################################-->
                                    <b-alert v-if="done" :show="alert.dismissCountDown"
                                      dismissible variant="success"
                                      @dismissed="dismissed"
                                      @dismiss-count-down="countDownChanged">
                                      <div class="text-center text-success m-auto message">
                                        <span class="lead">  
                                          Votre mot de pass Kemtag a été {{action}} avec succès.
                                          <br>Pour vous connecter à votre compte Kemtag cliquer
                                        <span class="ici"><router-link :to="'/login'"> ici </router-link> .</span>  
                                        </span>
                                        
                                        <br>
                                        <span>Cette alerte disparaîtra après {{alert.dismissCountDown}} secondes ... </span>
                                      </div>
                                               
                                    <b-progress
                                          variant="success"
                                          :max="alert.dismissSecs"
                                          :value="alert.dismissCountDown"
                                          height="4px"> </b-progress>
                                  </b-alert>
<!-- ######################################################################################################################-->
                                  <div id="login_alert" class="alert alert-danger" role="alert" v-else-if="error.token">
                                    <span class=" lead text-justify message">
                                    Ce mot de passe a déjà été réinitialisé ou un lien de réinitialisation plus
                                    récent vous a été envoyé. <br> Veuillez vérifier votre boîte de réception ou demander un autre lien de réinitialisation 
                                    <span  class="ici"> <router-link :to="'/login'"> ici </router-link> </span>.
                                    <br>
                                      Si c'est votre première connexion Veuillez demander à votre supérieur de vous envoyer un nouveau lien pour créer votre mot de passe.
                                    </span>
                                  </div>
<!-- ######################################################################################################################-->
                                    <div class="pdd-horizon-15" v-else-if="!error.token">
                                        <h2 class="mrg-btm-20">  {{title}} </h2>

<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *-->

                                        <div id="login_alert" class="alert alert-danger" role="alert" v-if="error.password">
                                            les mots de passe ne correspondent pas
                                            <i class="ti-close float-right mt-1 pointer" @click="error.password = false"></i><br>
                                        </div>
                                        
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *-->
                                  <div id="login_alert" class="alert alert-danger" role="alert" v-else-if="error.reset">
                                    {{error.msg}}
                                    <i class="ti-close float-right mt-1 pointer" @click="error.reset = false"></i><br>
                                  </div> 

<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *-->
                                                                                                                               
                                        <form autocomplete="off"  @submit.prevent="setPassword" >
                                            
                                          <b-form-group label="Adresse e-mail">
                                            <div class="input-icon form-group">
                                              <i class="fa fa-envelope-o"></i>
                                              <b-form-input  v-model="email" type="email" class="form-control" placeholder="Saisissez votre adresse email" required> 
                                              </b-form-input>
                                            </div>
                                          </b-form-group>
                                                                      
                                          <b-form-group :state="validateState('password')" label="Votre nouveau mot de passe">
                                            <div class="input-icon form-group">
                                              <i class="fa fa-key"></i>
                                              <b-form-input  v-model="password" :state="validateState('password')"
                                                      type="password" class="form-control" placeholder="Saisissez votre mot de passe" required> 
                                              </b-form-input>
                                            </div>
                                          </b-form-group>
                                          
                                          <b-form-group :state="validateState('password')" label="Confirmez votre nouveau mot de passe" >
                                            <div class="input-icon form-group">
                                              <i class="fa fa-key"></i>
                                              <b-form-input  v-model="password_confirmation" :state="validateState('password')"
                                                      type="password" class="form-control" placeholder="Confirmez votre mot de passe" required> 
                                              </b-form-input>
                                            </div>
                                          </b-form-group>
                                          
                                          <div class="form-group text-right">
                                          <router-link :to="'/login'" class="btn btn-default"> Annuler </router-link> 
                                          <button type="submit" class="btn btn-primary"  :class="error.password? 'disabled': ''" :disabled="error.password"> {{button}} </button>
                                          </div>
                                        </form>

                                        
                                        <div> 
                                          </div> 
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

    import api from "../../config/_api";

    export default {
        name: "SetPassword",
        data() {
        return {
            action : "réinitilisé",
            title : "",
            button : "",
            done : false,
            token: null,
            email: null,
            password: null,
            password_confirmation: null,
            error : {
              token : false,
              password : null,
              reset : false,
              msg : "",

            },
            validation : {
                  password :{
                        $dirty : false,
                        $error : false,
                  }
            },
            alert : {
                    dismissSecs: 10,
                    dismissCountDown: 0,
            }
        }
        },
        created() {
            this.token=this.$route.params.token;
            this.findToken();
        },
        watch:{
          password(){
            this.cmpPassword(this.password,this.password_confirmation);
          },
          password_confirmation(){
            this.cmpPassword(this.password_confirmation,this.password);
          },
        },
        methods: {
          cmpPassword(val1,val2){
              var cmp=val1.localeCompare(val2);

              if(val1==null || val2==null || val1.length==0 || val2.length==0){
                this.validation['password'].$dirty=false;
                this.validation['password'].$error=false;
                this.error.password=null;
              }

              else if(cmp==0){
                this.validation['password'].$dirty=true;
                this.validation['password'].$error=false;
                this.error.password=false;
              }
              
              else{
                this.validation['password'].$dirty=true;
                this.validation['password'].$error=true;
                this.error.password=true;
              }

          },
          validateState(name){
        const { $dirty, $error } = this.validation[name];
				return $dirty ? !$error : null;

          },
            findToken(){
                this.axios({url: api.url + 'password/find/'+this.token,method: 'GET' })
                .then(result => {
                    this.error.token=false;
                    this.title=   result.data.type==1 ? 'Réinitialisation de mot de passe' : result.data.type==2 ? 'Première Connexion ' : '';
                    this.button = result.data.type==1 ? 'Réinitialisation' : result.data.type==2 ? 'Créez votre mot de passe' : '';
                    this.action = result.data.type==1 ? 'réinitilisé ' : result.data.type==2 ? 'créé' : '';
                }, error => {
                    this.error.token=true;
                    this.error.msg=error;
                });
            },
            
            setPassword() {
              this.findToken();
              if (!this.error.token) {
                var data = {
                    email : this.email,
                    password : this.password,
                    password_confirmation : this.password_confirmation,
                    token : this.token,

                }
                  this.axios({url: api.url + 'password/reset',data : data, method: 'POST' })
                  .then(result => {
                    this.Succes();
                  }, error => {
                    //console.log(error.response.data.message);
                      this.Echec(error.response.data.error,error.response.data.message);
                  });
                }
            },
            countDownChanged(dismissCountDown) {
                this.alert.dismissCountDown = dismissCountDown;
            },
            showAlert() {
                this.alert.dismissCountDown = this.alert.dismissSecs;
            },
            dismissed(){
              this.$router.push('/login');
            },
            Succes(){
                    this.done=true;
                    this.error.reset=false;
                    this.Clear(); 
                    this.showAlert();
            },
            Echec(error,msg){
                    this.error.reset=true;
                    this.done=false;
                    if (error) {
                    this.error.msg=msg; 
                    }  
                    this.Clear();          
            },
            Clear(){      
                    this.email="";
                    this.password="";
                    this.password_confirmation="";

            }

        }
    }
</script>
<style>
.message{
    line-height:3rem;
    font-weight: 400;
}
.ici{
  font-style: italic;
  font-weight: bold;
}
</style>